import './_polyfills'
import navToggle from './_nav.js';

jQuery( document ).ready(() => {
	// stickyNav();
	navToggle();

} );
